import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SidebarWrapper from "../components/sidebar/Wrapper";
import Home from "../pages/Home";
import Archive from "../pages/Archive";
import Report from "../pages/Report";
import User from "../pages/User";
import { useAuth } from "../context/AuthContext";
import InvoicePage from "../pages/InvoiceLookup";
import InvoiceTable from "../pages/Milestone";
import InvoiceDetailPage from "../pages/MasterInvoiceDetails";
import InvoiceMilestonePage from "../pages/delete";

const routesConfig = [
    // { path: "/", element: <Home />, title: "Dashboard" },
    { path: "/merge", element: <Archive />, title: "Invoice Hub – Fetch, Merge & Edit." },
    { path: "/users", element: <User />, title: "Users", requiresAdmin: true },
    { path: "/report", element: <Report />, title: "Reports" },
    { path: "/invoice-lookup", element: <InvoicePage />, title: "Invoice Look-Up" },
    { path: "/master-invoice", element: <InvoiceTable />, title: "Master Invoice" },
    { path: "/master-invoice-details/:masterInvoiceId", element: <InvoiceDetailPage />, title: "Master Invoice Details" },
    { path: "/deleted-invoice", element: <InvoiceMilestonePage />, title: "Deleted Invoices and Milestones" },
];

const ProtectedRoute = ({ isAuthenticated, role, requiresAdmin, children }) => {
    const location = useLocation();

    if (!isAuthenticated) {
        // Redirect to login page and preserve the attempted URL
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requiresAdmin && role !== "admin") {
        // Redirect to a "Not Authorized" page or home if the user is not an admin
        return <Navigate to="/merge" replace />;
    }

    return children;
};

const AppRoutes = ({ isAuthenticated }) => {
    const location = useLocation();
    const { user } = useAuth(); // Get the user object from the AuthContext
    const role = user?.role;

    const currentRoute = routesConfig.find((route) => route.path === location.pathname);
    const pageTitle = currentRoute ? currentRoute.title : "Dashboard";

    return (
        <ProtectedRoute isAuthenticated={isAuthenticated}>
<div className="flex min-h-screen bg-gradient-to-br from-[#fdf6ec] via-[#f8f1e9] to-[#f3e7db]">
{/* Sidebar */}
          <SidebarWrapper className="w-64 flex-shrink-0 bg-white shadow-lg">
            {/* Header */}
            <header className="bg-gradient-to-r  from-blue-500  to-indigo-600 shadow-md flex-none">
              <div className="mx-auto px-6 py-6 flex items-center space-x-4">
                <h1 className="text-2xl font-bold text-white">{pageTitle}</h1>
              </div>
            </header>
      
            {/* Main Content */}
            <div className="flex-1 overflow-y-auto p-6">
              <Routes>
                {routesConfig.map(({ path, element, requiresAdmin }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <ProtectedRoute
                        isAuthenticated={isAuthenticated}
                        role={role}
                        requiresAdmin={requiresAdmin}
                      >
                        {element}
                      </ProtectedRoute>
                    }
                  />
                ))}
              </Routes>
            </div>
          </SidebarWrapper>
        </div>
      </ProtectedRoute>
      
    );
};

export default AppRoutes;
